module.exports = __webpack_public_path__ + "img/icone-mensagem.4952cb18.svg";